import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3014";

// Async thunks
export const fetchBillingCycles = createAsyncThunk(
  "billingCycle/fetchAll",
  async (params) => {
    const response = await axios.get(`${API_URL}/billing-cycle`, { params });
    return response.data;
  },
);

export const fetchBillingCycle = createAsyncThunk(
  "billingCycle/fetchOne",
  async (id) => {
    const response = await axios.get(`${API_URL}/billing-cycle/${id}`);
    return response.data;
  },
);

export const createBillingCycle = createAsyncThunk(
  "billingCycle/create",
  async (data) => {
    const response = await axios.post(`${API_URL}/billing-cycle`, data);
    return response.data;
  },
);

export const generateBillingCycles = createAsyncThunk(
  "billingCycle/generate",
  async ({ pksId, billingPeriod }) => {
    const response = await axios.post(
      `${API_URL}/billing-cycle/generate/${pksId}`,
      { billing_period: billingPeriod },
    );
    return response.data;
  },
);

export const processDueCycles = createAsyncThunk(
  "billingCycle/processDue",
  async () => {
    const response = await axios.post(`${API_URL}/billing-cycle/process-due`);
    return response.data;
  },
);
